import { type FC } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { checkIsActive, KTSVG, type WithChildren } from '../../../helpers';
import { useLayout } from '../../core';
import IsRouteOrActionAllowed from '../../../../app/utility/IsRouteOrActionAllowed';

interface Props {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  hasBullet?: boolean;
  permission?: string;
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  permission,
}) => {
  const { pathname, } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config, } = useLayout();
  const { aside, } = config;

  if (!IsRouteOrActionAllowed.IsRouteOrActionAllowed(permission as any)) {
    return null;
  }

  return (
    <div className="menu-item">
      <Link className={clsx('menu-link without-sub', { active: isActive, })} to={to}>
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot" />
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className="menu-icon">
            <KTSVG path={icon} className="svg-icon-2" />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('fs-2  me-3', fontIcon, { 'text-white': isActive, })} />}
        <span className="menu-title fs-5">{title}</span>
      </Link>
      {children}
    </div>
  );
};

export { AsideMenuItem };
